module.exports = __webpack_public_path__ + "img/Frente-32-01 on.9a1308ff.png";